import { BufferGeometry, Float32BufferAttribute, Line, LineDashedMaterial, Vector3 } from "three";
/**
 * Dashed line with no customizable width because it use gl_line. Scale not implemented yet
 */
export class DashedSingleLine extends Line {
    constructor(name, color, A = new Vector3(0, 0, 0), B = new Vector3(0, 0, 1)) {
        super(new BufferGeometry(), new LineDashedMaterial({ color: color }));
        this.name = name;
        this.interceptedByRaycaster = false;
        this.geometry.setAttribute("position", new Float32BufferAttribute([A.x, A.y, A.z, B.x, B.y, B.z], 3));
        this.computeLineDistances();
        this._A = A.clone();
        this._B = B.clone();
    }
    get A() {
        return this._A;
    }
    set A(value) {
        this._A.copy(value);
        this.update(0, value);
    }
    get B() {
        return this._B;
    }
    set B(value) {
        this._B.copy(value);
        this.update(1, value);
    }
    setAB(A, B) {
        this._A.copy(A);
        this._B.copy(B);
        const pos = this.geometry.getAttribute("position");
        const posArray = pos.array;
        posArray[0] = A.x;
        posArray[1] = A.y;
        posArray[2] = A.z;
        posArray[3] = B.x;
        posArray[4] = B.y;
        posArray[5] = B.z;
        pos.needsUpdate = true;
        this.computeLineDistances();
        this.geometry.computeBoundingSphere();
    }
    update(index, vec) {
        const pos = this.geometry.getAttribute("position");
        const posArray = pos.array;
        posArray[index * 3] = vec.x;
        posArray[index * 3 + 1] = vec.y;
        posArray[index * 3 + 2] = vec.z;
        pos.needsUpdate = true;
        this.computeLineDistances();
        this.geometry.computeBoundingSphere();
    }
}
//# sourceMappingURL=DashedSingleLine.js.map